<template src="./Painel.html"></template>

<script>
  import { mapMutations } from "vuex";  
  import store from "@/store";
  import moment from "moment";  
  import ocorrenciaCtrl from "@/services/ocorrencias";
  import acordo from "@/services/acordo";
  import agendaCtrl from "@/services/agendas";
  import usuario from "@/services/usuario";
  import {json2excel, excel2json} from 'js2excel';
  import QuantidadeParcela from '@/components/QuantidadeParcela'
  import ValoresParcela from '@/components/ValoresParcela'

  export default {
    name: 'Endereco',
    components: {
      QuantidadeParcela,
      ValoresParcela
    },
    data () {
      return {
        valid: true,
        date: new Date().toISOString().substr(0, 10),
        menu: false,
        modal: false,
        user: {},
        acordo: {},
        dialogConfirmation:false,
        dialogError: false,
        dialogParcela: false,
        editando: false,
        message: "",
        excluindo: {},
        cep: {},
        devedor: {},
        filtros: {},
        ocorrencias: [],
        agendas: [],
        funcionarios: [],
        clientes: [],
        valorTotalRecebido: 0,
        mesAtual: 0,
        mesPassado: 0
      }
    },
    async created () {
      let items = [];
      this.setLoading(true);
      let parcelas = await acordo.getGraph();
      let hoje = new moment().format('YYYY-MM');
      let mespassado = new moment().subtract(1, "M").format('YYYY-MM');
      parcelas.forEach(parcela => {
        if (parcela._id == hoje) {
          this.mesAtual += parcela.valorCliente;
        }
        if (parcela._id == mespassado) {
          this.mesPassado += parcela.valorCliente;
        }
        this.valorTotalRecebido += parcela.valorCliente;
      });
      // this.clientes = await cliente.getClientes();
      this.funcionarios = await usuario.getFuncionarios();

      if (store.getters.user) {
        this.user = await usuario.getUsuario(store.getters.user._id);
      }
      this.setLoading(false);
    },
    methods: {
      
      async buscarOcorrencias () {
        if (this.filtros.idfuncionario && this.date) {
          this.setLoading(true);
          if (this.user != null && this.user.acesso == "Admin") {
            this.ocorrencias = await ocorrenciaCtrl.getOcorrenciasUser({iduser: this.filtros.idfuncionario, date: this.date});
            this.agendas = await agendaCtrl.getAgendasUser({iduser: this.filtros.idfuncionario, date: this.date});
          } else if (this.user != null && this.user.acesso == "Cliente") {

          }
          this.setLoading(false);
        }
      },
      ...mapMutations({
        setLoading : "setLoading",
        setDevedor: "setDevedor",
      })
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/painel/Painel.vue